import { useState, useEffect, useCallback, useRef } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import Badge from "../../components/common/Badge/Badge";
import TabsNavigation from "../../components/common/TabsNavigation/TabsNavigation";
import Table from "../../components/common/Table/Table";
import ValidacionesHistorico from "../../components/common/ValidacionesHistorico/ValidacionesHistorico";
import "./FichaGestor.scss";
import DetalleLayout from "../../Layouts/DetalleLayout/DetalleLayout";
import { useZone } from "../../context/ZoneContext";
import { getApiInstance } from "../../utils/api";
import { CiClock1 } from "react-icons/ci";
import { CgDanger } from "react-icons/cg";
import { CiCircleCheck } from "react-icons/ci";
import { IoEyeOutline } from "react-icons/io5";
import { MdOutlineFileDownload } from "react-icons/md";
import Notification from "../../components/common/notification/notification";
import { formatDate } from "../../utils/utils";
import { addOrUpdateRecentItem } from "../../utils/utils";
import { mapList, mappedDataToFormData } from "../../utils/utils";
import { useTranslation } from "react-i18next";
import VisitaDetalleModal from "../../components/layout/Visitas/VisitaDetalleModal";
import {
    BADGE_VALORACION_VISITA,
    SECCIONES_INFORME_VISITA,
    VALORACIONES_VISITA,
    descargarInformeVisitaWord,
    formatFechaVisita,
    mapVisitas,
} from "../../components/layout/Visitas/visitaInforme";

const TABS_DATOS = [
    { id: "residuos", label: "Residuos" },
    { id: "documentacion", label: "Documentación" },
    { id: "facturas", label: "Facturas" },
    { id: "certificado", label: "Certificados" },
    { id: "tarifas", label: "Tarifas" },
    { id: "transporteGestionResiduos", label: "Transporte Gestión Residuos" },
    { id: "visitas", label: "Visitas" },
];

export default function FichaGestor({ user }) {
    const { t } = useTranslation();
    const { id } = useParams();
    // Permite enlazar a una pestaña concreta, p.ej. desde Informes de visitas:
    // /gestores/123?tab=visitas
    const [searchParams] = useSearchParams();
    const tabInicialDatos = TABS_DATOS.some(
        (tab) => tab.id === searchParams.get("tab")
    )
        ? searchParams.get("tab")
        : "documentacion";
    const [gestor, setGestor] = useState(null);
    const [documentos, setDocumentos] = useState([]);
    const [tiposDocumentos, setTiposDocumentos] = useState([]);
    const [tarifas, setTarifas] = useState([]);
    const [residuos, setResiduos] = useState([]);
    const [activeTabGeneral, setActiveTabGeneral] = useState("informacion");
    const [activeTabDatos, setActiveTabDatos] = useState(tabInicialDatos);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [certificados, setCertificados] = useState([]);
    const [facturas, setFacturas] = useState([]);
    const [transporteGestionResiduos, setTransporteGestionResiduos] =
        useState([]);
    const [isHistoricoModalOpen, setIsHistoricoModalOpen] = useState(false);
    const [documentoSeleccionado, setDocumentoSeleccionado] = useState(null);
    const [visitas, setVisitas] = useState([]);
    const [visitaSeleccionada, setVisitaSeleccionada] = useState(null);
    const [isVisitaModalOpen, setIsVisitaModalOpen] = useState(false);
    const notificationRef = useRef(null);
    const { selectedZone } = useZone();

    const getFormElementsDocumentosResiduos = () => {
        const codZonaLegal = selectedZone.value;
        const codTipoAutorizacion =
            codZonaLegal === "1" ? 18 : codZonaLegal === "2" ? 20 : 18;

        return [
            {
                titleVisible: false,
                elements: [
                    {
                        name: "codProveedor",
                        type: "text",
                        required: true,
                        disabled: false,
                        visible: false,
                        defaultValue: `${id}`,
                    },
                    {
                        name: "codtipoDocumento",
                        type: "text",
                        required: true,
                        disabled: false,
                        visible: false,
                    },
                    {
                        name: "sectionObligatoria",
                        type: "section",
                        label: "Documentación obligatoria:",
                        visible: true,
                    },
                    {
                        name: "autorizacionTratamiento",
                        type: "checkbox",
                        label: "Autorización tratamiento de residuos",
                        required: false,
                        disabled: false,
                        labelVisible: true,
                        visible: true,
                        exclusiveGroup: "tipoDocumentacionResiduos",
                        valueMapField: "codtipoDocumento",
                        valueWhenChecked: codTipoAutorizacion,
                    },
                    {
                        name: "sectionNoObligatoria",
                        type: "section",
                        label: "Documentación no obligatoria:",
                        visible: true,
                    },
                    {
                        name: "certificadoISO14001",
                        type: "checkbox",
                        label: "Certificados ISO 14001",
                        required: false,
                        disabled: false,
                        labelVisible: true,
                        visible: true,
                        exclusiveGroup: "tipoDocumentacionResiduos",
                        valueMapField: "codtipoDocumento",
                        valueWhenChecked: 19,
                    },
                    {
                        name: "nima",
                        type: "checkbox",
                        label: "NIMA",
                        required: false,
                        disabled: false,
                        labelVisible: true,
                        visible: true,
                        exclusiveGroup: "tipoDocumentacionResiduos",
                        valueMapField: "codtipoDocumento",
                        valueWhenChecked: 5,
                    },
                    {
                        name: "codigoAutorizacion",
                        type: "text",
                        label: "Código Autorización",
                        placeholder: "Ingrese el código de autorización",
                        required: true,
                        disabled: false,
                        labelVisible: true,
                        visible: true,
                        visibleWhen: {
                            field: "autorizacionTratamiento",
                            value: true,
                        },
                    },
                    {
                        name: "fechaIni",
                        type: "date",
                        label: "Fecha Inicio",
                        placeholder: "Seleccione fecha",
                        required: true,
                        disabled: false,
                        labelVisible: true,
                        visible: true,
                    },
                    {
                        name: "fechaFin",
                        type: "date",
                        label: "Fecha Fin",
                        placeholder: "Seleccione fecha",
                        required: true,
                        disabled: false,
                        labelVisible: true,
                        visible: true,
                    },
                    {
                        name: "descripcion",
                        type: "textarea",
                        label: "Descripción",
                        placeholder: "Ingrese una descripción",
                        required: false,
                        disabled: false,
                        labelVisible: true,
                        visible: true,
                        rows: 3,
                    },
                    {
                        name: "fichero",
                        type: "document",
                        label: "Subir documento",
                        placeholder: "Seleccione un archivo",
                        required: true,
                        disabled: false,
                        labelVisible: true,
                        visible: true,
                    },
                    {
                        name: "codZona",
                        type: "text",
                        required: true,
                        disabled: false,
                        visible: false,
                        defaultValue: `${selectedZone.value}`,
                    },
                    {
                        name: "codZonaLegal",
                        type: "text",
                        required: true,
                        disabled: false,
                        visible: false,
                        defaultValue: `${selectedZone.value}`,
                    },
                ],
            },
        ];
    };

    const getFormElementsDocumentos = (tipo) => {
        const codPais = gestor?.codPais;

        let codTipoDocumentoValue = null;
        if (tipo === "factura") {
            if (codPais === 2) {
                codTipoDocumentoValue = 15;
            } else if (codPais === 3) {
                codTipoDocumentoValue = 22;
            } else {
                codTipoDocumentoValue = 22;
            }
        } else if (tipo === "certificado") {
            codTipoDocumentoValue = 14;
        }

        const isDocumento = tipo === "documento";

        return [
            {
                elements: [
                    {
                        name: "codProveedor",
                        type: "text",
                        required: true,
                        disabled: false,
                        visible: false,
                        defaultValue: `${id}`,
                    },
                    {
                        name: "codtipoDocumento",
                        type: "select",
                        label: "Tipo de documento",
                        placeholder: "Seleccione el tipo de documento",
                        required: true,
                        disabled: !isDocumento, // deshabilitado si no es documento
                        labelVisible: true,
                        visible: isDocumento, // oculto si es factura o certificado
                        options: tiposDocumentos,
                        defaultValue: codTipoDocumentoValue ?? undefined,
                    },
                    {
                        name: "descripcion",
                        type: "text",
                        label: "Nombre del archivo",
                        placeholder: "Ingrese el nombre del archivo",
                        required: isDocumento,
                        disabled: false,
                        labelVisible: true,
                        visible: true,
                    },
                    {
                        name: "fechaIni",
                        type: "date",
                        label: "Fecha de validez",
                        required: isDocumento,
                        disabled: false,
                        labelVisible: true,
                        visible: true,
                    },
                    {
                        name: "fechaFin",
                        type: "date",
                        label: "Fecha de vencimiento",
                        required: isDocumento,
                        disabled: false,
                        labelVisible: true,
                        visible: true,
                    },
                    {
                        name: "fichero",
                        type: "document",
                        label: "Archivo",
                        placeholder: "Seleccione un archivo",
                        required: true,
                        disabled: false,
                        labelVisible: true,
                        visible: true,
                    },
                    {
                        name: "observaciones",
                        type: "textarea",
                        label: "Observaciones",
                        placeholder: "Ingrese observaciones adicionales",
                        required: false,
                        disabled: false,
                        labelVisible: true,
                        visible: true,
                        rows: 3,
                    },
                    {
                        name: "codZona",
                        type: "text",
                        required: true,
                        disabled: false,
                        visible: false,
                        defaultValue: `${selectedZone.value}`,
                    },
                    {
                        name: "codZonaLegal",
                        type: "text",
                        required: true,
                        disabled: false,
                        visible: false,
                        defaultValue: `${selectedZone.value}`,
                    },
                ],
            },
        ];
    };

    // El informe se reparte en cuatro pasos: FormModal muestra un grupo cada
    // vez y navega con las flechas del titulo, asi que el panel lateral ya no
    // tiene que ensancharse para que quepan las siete secciones de texto.
    const getFormElementsVisita = () => {
        const seccionesTexto = SECCIONES_INFORME_VISITA.map((seccion) => ({
            name: seccion.key,
            type: "textarea",
            label: seccion.label,
            placeholder: `Escriba aquí ${seccion.label.toLowerCase()}`,
            required: false,
            disabled: false,
            labelVisible: true,
            visible: true,
        }));

        return [
            {
                title: "Datos de la visita",
                titleVisible: true,
                elements: [
                    {
                        name: "codProveedor",
                        type: "text",
                        required: true,
                        disabled: false,
                        visible: false,
                        defaultValue: `${id}`,
                    },
                    {
                        name: "fechaVisita",
                        type: "date",
                        label: "Fecha de la visita",
                        required: true,
                        disabled: false,
                        labelVisible: true,
                        visible: true,
                    },
                    {
                        name: "titulo",
                        type: "text",
                        label: "Título del informe",
                        placeholder:
                            "Ej. Informe de visita a gestor de residuos RESIDECA",
                        required: false,
                        disabled: false,
                        labelVisible: true,
                        visible: true,
                    },
                    {
                        name: "ubicacion",
                        type: "text",
                        label: "Ubicación",
                        placeholder: "Ej. Dacón, Ourense",
                        required: false,
                        disabled: false,
                        labelVisible: true,
                        visible: true,
                    },
                    {
                        name: "tipoInstalacion",
                        type: "text",
                        label: "Tipo de instalación",
                        placeholder:
                            "Ej. Gestor de residuos de construcción y demolición (RCD)",
                        required: false,
                        disabled: false,
                        labelVisible: true,
                        visible: true,
                    },
                    {
                        name: "tecnico",
                        type: "text",
                        label: "Técnico que realiza la visita",
                        placeholder: "Nombre y apellidos",
                        required: false,
                        disabled: false,
                        labelVisible: true,
                        visible: true,
                    },
                    {
                        name: "codValoracion",
                        type: "select",
                        label: "Valoración",
                        placeholder: "Seleccione la valoración de la visita",
                        required: false,
                        disabled: false,
                        labelVisible: true,
                        visible: true,
                        options: VALORACIONES_VISITA,
                    },
                ],
            },
            {
                title: "Contenido del informe (1/2)",
                titleVisible: true,
                elements: seccionesTexto.slice(0, 4),
            },
            {
                title: "Contenido del informe (2/2)",
                titleVisible: true,
                elements: seccionesTexto.slice(4),
            },
            {
                title: "Documento",
                titleVisible: true,
                elements: [
                    {
                        name: "fichero",
                        type: "document",
                        label: "Adjunto (opcional). Al editar, déjalo vacío para conservar el actual",
                        placeholder: "Seleccione un archivo",
                        required: false,
                        disabled: false,
                        labelVisible: true,
                        visible: true,
                    },
                ],
            },
        ];
    };

    useEffect(() => {
        if (gestor != null) {
            addOrUpdateRecentItem({
                id: gestor.codProveedor,
                title: gestor.nombre,
                type: "gestores",
            });
        }
    }, [gestor]);

    useEffect(() => {
        if (gestor != null) {
            addOrUpdateRecentItem({
                id: gestor.codProveedor,
                title: gestor.nombre,
                type: "gestores",
            });
        }
    }, [gestor]);

    const fetchGestor = async (id) => {
        try {
            const api = getApiInstance();
            console.log(`Fetching gestor with ID: ${id}`);
            const response = await api.get(
                `/api/Proveedores/GetProveedorById/${id}`
            );
            return await response.data;
        } catch (error) {
            console.error("Error fetching gestor:", error);
            throw error;
        }
    };

    const fetchDocumentos = async (id) => {
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/GestorDocumentos/GetDocumentosFromGestor/${id}`
            );
            return await response.data;
        } catch (error) {
            console.error("Error fetching gestor:", error);
            throw error;
        }
    };

    const handleDocumentosUpdate = useCallback(async () => {
        try {
            const data = await fetchDocumentos(id);
            const codDocumento = (doc) => Number(doc.codTipoDocumento);
            setDocumentos(
                data.filter(
                    (doc) =>
                        ![15, 22, 14].includes(codDocumento(doc))
                )
            );
            setCertificados(
                data.filter((doc) => codDocumento(doc) === 14)
            );
            setFacturas(
                data.filter((doc) =>
                    [15, 22].includes(codDocumento(doc))
                )
            );
        } catch (error) {
            console.error("Error refrescando documentos:", error);
        }
    }, [id]);

    const fetchVisitas = async (id) => {
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/ProveedoresVisitas/GetVisitasFromGestor/${id}`
            );
            return await response.data;
        } catch (error) {
            console.error("Error fetching visitas:", error);
            throw error;
        }
    };

    const handleVisitasUpdate = useCallback(async () => {
        try {
            const data = await fetchVisitas(id);
            setVisitas(mapVisitas(data));
        } catch (error) {
            console.error("Error refrescando visitas:", error);
        }
    }, [id]);

    const handleVerVisita = (visita) => {
        setVisitaSeleccionada(visita);
        setIsVisitaModalOpen(true);
    };

    // Word de un informe suelto, el mismo que ofrece el modal de detalle
    const handleExportarVisitaWord = async (visita) => {
        try {
            await descargarInformeVisitaWord(visita);
        } catch (err) {
            console.error("Error exportando el informe de visita a Word:", err);
            notificationRef.current?.addNotification(
                "No se pudo generar el Word del informe de visita",
                "error"
            );
        }
    };

    const fetchTarifas = async (id) => {
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/Tarifa/GetTarifasByProveedor/${id}`
            );
            return await response.data;
        } catch (error) {
            console.error("Error fetching gestor:", error);
            throw error;
        }
    };

    const fetchResiduos = async (id) => {
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/Proveedores/GetResiduosByProveedor/${id}`
            );
            return await response.data;
        } catch (error) {
            console.error("Error fetching gestor:", error);
            throw error;
        }
    };

    const fetchTransporteGestionResiduos = async (id) => {
        try {
            const api = getApiInstance();
            const response = await api.get(
                `/api/ResiduosObra/GetTransporteGestionResiduosByProveedor/${id}`
            );
            return await response.data;
        } catch (error) {
            console.error(
                "Error fetching transporte gestión residuos:",
                error
            );
            throw error;
        }
    };

    const handleVerValidaciones = (row) => {
        setDocumentoSeleccionado(row);
        setIsHistoricoModalOpen(true);
    };

    const fetchTiposDocumentos = async () => {
        try {
            // Productor = 1,
            // Gestor = 2,
            // Obra = 3,
            const api = getApiInstance();
            const response = await api.get(
                `/api/Documentos/GetTiposDocumentosByTipoEntidad/2`
            );
            return await response.data;
        } catch (error) {
            console.error("Error fetching tipos documentos:", error);
            throw error;
        }
    };

    useEffect(() => {
        const loadGestorData = async () => {
            try {
                setLoading(true);
                setError(null);

                const results = await Promise.allSettled([
                    fetchGestor(id),
                    fetchDocumentos(id),
                    fetchTarifas(id),
                    fetchTiposDocumentos(),
                    fetchResiduos(id),
                    fetchTransporteGestionResiduos(id),
                    fetchVisitas(id),
                ]);

                const [
                    gestorRes,
                    docRes,
                    tarifaRes,
                    tiposDocRes,
                    residuosRes,
                    transporteGestionResiduosRes,
                    visitasRes,
                ] = results;

                const gestorData =
                    gestorRes.status === "fulfilled" ? gestorRes.value : null;
                const documentosData =
                    docRes.status === "fulfilled" ? docRes.value : [];
                const tarifasData =
                    tarifaRes.status === "fulfilled" ? tarifaRes.value : [];
                const residuosData =
                    residuosRes.status === "fulfilled" ? residuosRes.value : [];
                const tiposDocumentosData =
                    tiposDocRes.status === "fulfilled" ? tiposDocRes.value : [];
                const transporteGestionResiduosData =
                    transporteGestionResiduosRes.status === "fulfilled"
                        ? transporteGestionResiduosRes.value
                        : [];
                const visitasData =
                    visitasRes.status === "fulfilled" ? visitasRes.value : [];

                setGestor(gestorData);
                setVisitas(mapVisitas(visitasData));

                const codDocumento = (doc) => Number(doc.codTipoDocumento);

                setDocumentos(
                    documentosData.filter(
                        (doc) =>
                            codDocumento(doc) !== 15 &&
                            codDocumento(doc) !== 22 &&
                            codDocumento(doc) !== 14
                    )
                ); // Documentación: excluimos facturas (15/22) y certificados (14)
                setTarifas(tarifasData);
                setResiduos(residuosData);
                setCertificados(
                    documentosData.filter(
                        (doc) => codDocumento(doc) === 14
                    )
                ); // solo certificados
                setFacturas(
                    documentosData.filter(
                        (doc) =>
                            codDocumento(doc) === 15 ||
                            codDocumento(doc) === 22
                    )
                ); // solo facturas
                setTransporteGestionResiduos(transporteGestionResiduosData);
                setTiposDocumentos([
                    ...mapList(
                        tiposDocumentosData,
                        "descripcion",
                        "codTipoDocumento"
                    ),
                ]);

                // opcional: si gestorRes rechazó por algo distinto a 404, mostrarlo
                if (gestorRes.status === "rejected") {
                    setError(
                        gestorRes.reason?.message || "Error al cargar gestor"
                    );
                }
            } catch (err) {
                console.error("Error cargando datos del gestor:", err);
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        if (id) loadGestorData();
    }, [id]);

    const getEstadoBadge = (estado) => {
        const num = String(estado);
        const estadoConfig = {
            "0": { type: "info", label: "Sin documento", Icon: CiClock1 },
            "1": { type: "info", label: "Pendiente", Icon: CiClock1 },
            "2": { type: "warning", label: "Incidencia", Icon: CgDanger },
            "3": { type: "success", label: "Validado", Icon: CiCircleCheck },
            "4": { type: "danger", label: "Expirado", Icon: CiCircleCheck },
            VALIDADO: {
                type: "success",
                label: "Validado",
                Icon: CiCircleCheck,
            },
            PENDIENTE: { type: "info", label: "Pendiente", Icon: CiClock1 },
            INCIDENCIA: {
                type: "warning",
                label: "Incidencia",
                Icon: CgDanger,
            },
            VENCIDO: { type: "danger", label: "Vencido", Icon: CgDanger },
            ACTIVA: { type: "success", label: "Activa", Icon: CiCircleCheck },
        };
        return estadoConfig[num] || estadoConfig[estado] || estadoConfig["1"];
    };

    const tabsGeneral = [
        { id: "informacion", label: "Información General" },
    ];

    const tabsDatos = TABS_DATOS;

    const renderInformacionGeneral = () => (
        <div className="ficha-gestor__info">
            <div className="ficha-gestor__field">
                <label>Nombre:</label>
                <span>{gestor.nombre}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>CIF:</label>
                <span>{gestor.cif}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Contacto:</label>
                <span>{gestor.contacto}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Teléfono:</label>
                <span>{gestor.telefono}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Email:</label>
                <span>{gestor.email}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Dirección:</label>
                <span>{gestor.direccion}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Localidad:</label>
                <span>{gestor.localidad}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Código postal:</label>
                <span>{gestor.codigoPostal}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>País:</label>
                <span>{gestor.pais}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Comunidad:</label>
                <span>{gestor.comunidad}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Provincia:</label>
                <span>{gestor.provincia}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Estado:</label>
                <span className="ficha-gestor__field-badge">
                    <Badge
                        variant={getEstadoBadge(gestor.codEstado).type}
                        Icon={getEstadoBadge(gestor.codEstado).Icon}
                    >
                        {getEstadoBadge(gestor.codEstado).label}
                    </Badge>
                </span>
            </div>
            <div className="ficha-gestor__field">
                <label>Tipo:</label>
                <span>{gestor.tipo}</span>
            </div>
            {/* Los NIMA solo se rellenan en gestores de España */}
            {gestor.nimaTransporte && (
                <div className="ficha-gestor__field">
                    <label>NIMA Transporte:</label>
                    <span>{gestor.nimaTransporte}</span>
                </div>
            )}
            {gestor.nimaGestionFinal && (
                <div className="ficha-gestor__field">
                    <label>NIMA Gestión final:</label>
                    <span>{gestor.nimaGestionFinal}</span>
                </div>
            )}
        </div>
    );

    const renderResiduos = () => (
        <div className="ficha-gestor__residuos">
            <h3 className="ficha-gestor__residuos-title">
                Residuos Autorizados
            </h3>
            <Table
                columns={[
                    {
                        key: "codResiduo",
                        label: "ID",
                        visible: false,
                    },
                    {
                        key: "codigo",
                        label: "Código Obra",
                        visible: true,
                        sortable: true,
                    },
                    {
                        key: "nombre",
                        label: "Residuo",
                        visible: true,
                        sortable: true,
                        visibleOnExpand: true,
                    },
                ]}
                dataTable={residuos}
                noResultsMessage="No hay residuos disponibles"
                rowsPerPage={10}
                showCheckboxes={false}
                elementName="Residuo"
                stateProp="codEstado"
                searchTerms={["codigo", "nombre"]}
            ></Table>
        </div>
    );

    const renderVisitas = () => (
        <div className="ficha-gestor__visitas">
            <Table
                columns={[
                    {
                        key: "fechaVisita",
                        label: "Fecha",
                        visible: true,
                        sortable: true,
                        render: (row) => formatFechaVisita(row.fechaVisita),
                    },
                    {
                        key: "titulo",
                        label: "Informe",
                        visible: true,
                        sortable: true,
                        bold: true,
                    },
                    {
                        key: "tecnico",
                        label: "Técnico",
                        visible: true,
                        sortable: true,
                    },
                    {
                        key: "valoracion",
                        label: "Valoración",
                        visible: true,
                        sortable: true,
                        render: (row) => {
                            const badge =
                                BADGE_VALORACION_VISITA[row.codValoracion];
                            if (!badge) return "-";
                            return (
                                <Badge variant={badge.type} Icon={badge.Icon}>
                                    {badge.label}
                                </Badge>
                            );
                        },
                    },
                    {
                        key: "documento",
                        label: "Adjunto",
                        visible: true,
                        sortable: false,
                        type: "document",
                        documentProp: "ficheroBase64",
                    },
                ]}
                dataTable={visitas}
                onDataUpdate={handleVisitasUpdate}
                keyProp="codVisita"
                sortProp="fechaVisita"
                searchTerms={["titulo", "tecnico", "ubicacion"]}
                noResultsMessage="Aún no hay visitas registradas"
                rowsPerPage={10}
                showCheckboxes={false}
                elementName="Visita"
                stateProp=""
                actions={[
                    {
                        label: "Ver informe",
                        action: (row) => handleVerVisita(row),
                        icon: <IoEyeOutline size={16} />,
                    },
                    {
                        label: "Exportar a Word",
                        action: (row) => handleExportarVisitaWord(row),
                        icon: <MdOutlineFileDownload size={16} />,
                    },
                    "Editar",
                    "Eliminar",
                ]}
                formElements={getFormElementsVisita()}
                modalAddTitle="Nuevo informe de visita"
                addApiUrl="/api/ProveedoresVisitas/SetVisita"
                editApiUrl="/api/ProveedoresVisitas/UpdateVisita"
                deleteApiUrl="/api/ProveedoresVisitas/DeleteVisita"
                // El adjunto es opcional: sin este mapper la tabla enviaría JSON
                // cuando no hay fichero y multipart cuando lo hay.
                payloadMapper={(payload) =>
                    payload instanceof FormData
                        ? payload
                        : mappedDataToFormData(payload)
                }
                successMessages={{
                    add: "Informe de visita creado correctamente",
                    edit: "Informe de visita actualizado correctamente",
                    delete: "Informe de visita eliminado correctamente",
                }}
                loading={loading}
                userCodAcceso={Number(user.codAcceso)}
                userCodPerfil={Number(user.role)}
                excludeFields={["titulo", "codVisita", "codProveedor", "codObra", "introduccion", "objetivos", "descripcion", "conclusiones", "descripcionInstalacion", "observaciones", "ficheroBase64", "fichero", "documento", "codUsuario", "desarrollo", "recomendaciones", "valoracion", "proveedor","fechaAlta"]}
            />
        </div>
    );

    const renderGeneralContent = () => {
        switch (activeTabGeneral) {
            default:
                return renderInformacionGeneral();
        }
    };

    const renderDatosContent = () => {
        switch (activeTabDatos) {
            case "residuos":
                return renderResiduos();
            case "documentacion":
                return (
                    <div className="ficha-gestor__documentacion">
                        <Table
                            columns={[
                                {
                                    key: "tipoDocumento",
                                    label: "Tipo de documento",
                                    visible: true,
                                    sortable: true,
                                },
                                {
                                    key: "documento",
                                    label: "Documento",
                                    visible: true,
                                    sortable: true,
                                    type: "document",
                                    documentProp: "ficheroBase64",
                                },
                                {
                                    key: "validez",
                                    label: "Validez",
                                    visible: true,
                                    sortable: true,
                                    render: (row) =>
                                        `${formatDate(
                                            row.fechaIni
                                        )} - ${formatDate(row.fechaFin)}`,
                                },
                                {
                                    key: "codEstado",
                                    label: "Validación",
                                    visible: true,
                                    sortable: true,
                                },
                            ]}
                            dataTable={documentos}
                            onDataUpdate={handleDocumentosUpdate}
                            keyProp="codDocumento"
                            searchTerms={[
                                "tipoDocumento",
                                "documento",
                                "validez",
                            ]}
                            noResultsMessage="No hay documentos disponibles"
                            rowsPerPage={10}
                            showCheckboxes={false}
                            actions={[
                                {
                                    label: "Validar",
                                    actionType: "validate",
                                    icon: <CiCircleCheck size={16} />,
                                },
                                {
                                    label: "Ver validaciones",
                                    action: (row) =>
                                        handleVerValidaciones(row),
                                    icon: <CiClock1 size={16} />,
                                },
                                "Editar",
                                "Eliminar",
                            ]}
                            elementName="Documento"
                            stateProp="codEstado"
                            states={[
                                { type: "primary", label: "", Icon: null },
                                {
                                    type: "info",
                                    label: "Pendiente de validar",
                                    Icon: CiClock1,
                                },
                                {
                                    type: "warning",
                                    label: "Validación con incidencias",
                                    Icon: CgDanger,
                                },
                                {
                                    type: "success",
                                    label: "Validado",
                                    Icon: CiCircleCheck,
                                },
                                {
                                    type: "danger",
                                    label: "Expirado",
                                    Icon: CiCircleCheck,
                                },
                            ]}
                            stateChangeOptions={[
                                { value: "1", label: "Pendiente de validar" },
                                {
                                    value: "2",
                                    label: "Validación con incidencias",
                                },
                                { value: "3", label: "Validado" },
                                { value: "4", label: "Expirado" },
                            ]}
                            stateChangeUrl="/api/Validaciones/SetValidacion"
                            formElements={getFormElementsDocumentosResiduos()}
                            modalAddTitle="Asociar un documento al gestor"
                            addApiUrl="/api/GestorDocumentos/SetDocumento"
                            editApiUrl="/api/GestorDocumentos/UpdateDocumento"
                            deleteApiUrl="/api/GestorDocumentos/DeleteDocumento"
                            loading={loading}
                            userCodAcceso={Number(user.codAcceso)}
                            userCodPerfil={Number(user.role)}
                        />
                    </div>
                );
            case "tarifas":
                return (
                    <div className="ficha-gestor__tarifas">
                        <Table
                            columns={[
                                {
                                    key: "descr",
                                    label: "Descripción",
                                    visible: true,
                                    sortable: true,
                                },
                                {
                                    key: "fechaInicio",
                                    label: "Fecha Inicio",
                                    visible: true,
                                    sortable: true,
                                    type: "date",
                                },
                                {
                                    key: "fechaFin",
                                    label: "Fecha Fin",
                                    visible: true,
                                    sortable: true,
                                    type: "date",
                                },
                            ]}
                            dataTable={tarifas}
                            onDataUpdate={(newData) => setTarifas(newData)}
                            keyProp="codTarifa"
                            searchTerms={["descr", "fechaInicio", "fechaFin"]}
                            noResultsMessage="No hay tarifas disponibles"
                            rowsPerPage={10}
                            showCheckboxes={false}
                            actions={["Editar", "Eliminar"]}
                            elementName="Tarifa"
                            formElements={[
                                {
                                    elements: [
                                        {
                                            name: "codProveedor",
                                            type: "text",
                                            required: true,
                                            disabled: false,
                                            visible: false,
                                            defaultValue: Number(id),
                                        },
                                        {
                                            name: "proveedor",
                                            type: "text",
                                            label: "Proveedor",
                                            required: true,
                                            disabled: true,
                                            visible: true,
                                            defaultValue: `${gestor?.nombre}`,
                                        },
                                        {
                                            name: "descr",
                                            type: "textarea",
                                            label: "Descripción",
                                            placeholder:
                                                "Ingrese una descripción",
                                            required: false,
                                            disabled: false,
                                            labelVisible: true,
                                            visible: true,
                                            rows: 3,
                                        },
                                        {
                                            name: "fechaInicio",
                                            type: "date",
                                            label: "Fecha inicio",
                                            placeholder: "Seleccione fecha",
                                            required: true,
                                            disabled: false,
                                            labelVisible: true,
                                            visible: true,
                                        },
                                        {
                                            name: "fechaFin",
                                            type: "date",
                                            label: "Fecha fin",
                                            placeholder: "Seleccione fecha",
                                            required: true,
                                            disabled: false,
                                            labelVisible: true,
                                            visible: true,
                                        },
                                    ],
                                },
                            ]}
                            addApiUrl="/api/Tarifa/SetTarifa"
                            editApiUrl="/api/Tarifa/EditTarifa"
                            deleteApiUrl="/api/Tarifa/DeleteTarifa"
                            loading={loading}
                            userCodAcceso={Number(user.codAcceso)}
                            userCodPerfil={Number(user.role)}
                        />
                    </div>
                );
            case "certificado":
                return (
                    <div className="ficha-gestor__documentacion">
                        <Table
                            columns={[
                                {
                                    key: "documento",
                                    label: "Documento",
                                    visible: true,
                                    sortable: true,
                                    type: "document",
                                    documentProp: "ficheroBase64",
                                },
                                {
                                    key: "validez",
                                    label: "Validez",
                                    visible: true,
                                    sortable: true,
                                    render: (row) =>
                                        `${formatDate(
                                            row.fechaIni
                                        )} - ${formatDate(row.fechaFin)}`,
                                },
                                {
                                    key: "codEstado",
                                    label: "Validación",
                                    visible: true,
                                    sortable: true,
                                },
                            ]}
                            dataTable={certificados}
                            onDataUpdate={(newData) => setCertificados(newData)}
                            keyProp="codDocumento"
                            searchTerms={["documento", "validez"]}
                            noResultsMessage="No hay certificados disponibles"
                            rowsPerPage={10}
                            showCheckboxes={false}
                            actions={[
                                {
                                    label: "Validar",
                                    actionType: "validate",
                                    icon: <CiCircleCheck size={16} />,
                                },
                                {
                                    label: "Ver validaciones",
                                    action: (row) =>
                                        handleVerValidaciones(row),
                                    icon: <CiClock1 size={16} />,
                                },
                                "Eliminar",
                            ]}
                            elementName="Certificado"
                            stateProp="codEstado"
                            states={[
                                { type: "primary", label: "", Icon: null },
                                {
                                    type: "info",
                                    label: "Pendiente de validar",
                                    Icon: CiClock1,
                                },
                                {
                                    type: "warning",
                                    label: "Validación con incidencias",
                                    Icon: CgDanger,
                                },
                                {
                                    type: "success",
                                    label: "Validado",
                                    Icon: CiCircleCheck,
                                },
                                {
                                    type: "danger",
                                    label: "Expirado",
                                    Icon: CiCircleCheck,
                                },
                            ]}
                            stateChangeOptions={[
                                { value: "1", label: "Pendiente de validar" },
                                {
                                    value: "2",
                                    label: "Validación con incidencias",
                                },
                                { value: "3", label: "Validado" },
                                { value: "4", label: "Expirado" },
                            ]}
                            stateChangeUrl="/api/Validaciones/SetValidacion"
                            formElements={getFormElementsDocumentos(
                                "certificado"
                            )}
                            addApiUrl="/api/GestorDocumentos/SetDocumento"
                            deleteApiUrl="/api/GestorDocumentos/DeleteDocumento"
                            loading={loading}
                            userCodAcceso={Number(user.codAcceso)}
                            userCodPerfil={Number(user.role)}
                        />
                    </div>
                );
            case "facturas":
                return (
                    <div className="ficha-gestor__documentacion">
                        <Table
                            columns={[
                                {
                                    key: "documento",
                                    label: "Documento",
                                    visible: true,
                                    sortable: true,
                                    type: "document",
                                    documentProp: "ficheroBase64",
                                },
                                {
                                    key: "validez",
                                    label: "Validez",
                                    visible: true,
                                    sortable: true,
                                    render: (row) =>
                                        `${formatDate(
                                            row.fechaIni
                                        )} - ${formatDate(row.fechaFin)}`,
                                },
                                {
                                    key: "codEstado",
                                    label: "Validación",
                                    visible: true,
                                    sortable: true,
                                },
                            ]}
                            dataTable={facturas}
                            onDataUpdate={(newData) => setFacturas(newData)}
                            keyProp="codDocumento"
                            searchTerms={["documento", "validez"]}
                            noResultsMessage="No hay facturas disponibles"
                            rowsPerPage={10}
                            showCheckboxes={false}
                            actions={[
                                {
                                    label: "Validar",
                                    actionType: "validate",
                                    icon: <CiCircleCheck size={16} />,
                                },
                                {
                                    label: "Ver validaciones",
                                    action: (row) =>
                                        handleVerValidaciones(row),
                                    icon: <CiClock1 size={16} />,
                                },
                                "Eliminar",
                            ]}
                            elementName="Factura"
                            stateProp="codEstado"
                            states={[
                                { type: "primary", label: "", Icon: null },
                                {
                                    type: "info",
                                    label: "Pendiente de validar",
                                    Icon: CiClock1,
                                },
                                {
                                    type: "warning",
                                    label: "Validación con incidencias",
                                    Icon: CgDanger,
                                },
                                {
                                    type: "success",
                                    label: "Validado",
                                    Icon: CiCircleCheck,
                                },
                                {
                                    type: "danger",
                                    label: "Expirado",
                                    Icon: CiCircleCheck,
                                },
                            ]}
                            stateChangeOptions={[
                                { value: "1", label: "Pendiente de validar" },
                                {
                                    value: "2",
                                    label: "Validación con incidencias",
                                },
                                { value: "3", label: "Validado" },
                                { value: "4", label: "Expirado" },
                            ]}
                            stateChangeUrl="/api/Validaciones/SetValidacion"
                            formElements={getFormElementsDocumentos("factura")}
                            addApiUrl="/api/GestorDocumentos/SetDocumento"
                            deleteApiUrl="/api/GestorDocumentos/DeleteDocumento"
                            loading={loading}
                            userCodAcceso={Number(user.codAcceso)}
                            userCodPerfil={Number(user.role)}
                        />
                    </div>
                );
            case "transporteGestionResiduos":
                return (
                    <div className="ficha-gestor__transporte-gestion-residuos">
                        <Table
                            columns={[
                                {
                                    key: "codObra",
                                    label: "Centro productor",
                                    visible: true,
                                    sortable: true,
                                },
                                {
                                    key: "cantidadTransporte",
                                    label: "Cantidades por transporte (kg)",
                                    visible: true,
                                    sortable: true,
                                    type: "number",
                                    render: (row) =>
                                        `${new Intl.NumberFormat(
                                            "es-ES"
                                        ).format(row.cantidadTransporte ?? 0)} kg`,
                                },
                                {
                                    key: "cantidadGestionFinal",
                                    label: "Cantidades por destino final (kg)",
                                    visible: true,
                                    sortable: true,
                                    type: "number",
                                    render: (row) =>
                                        `${new Intl.NumberFormat(
                                            "es-ES"
                                        ).format(
                                            row.cantidadGestionFinal ?? 0
                                        )} kg`,
                                },
                                {
                                    key: "cantidadTotal",
                                    label: "Cantidades de residuo generadas (kg)",
                                    visible: true,
                                    sortable: true,
                                    type: "number",
                                    render: (row) =>
                                        `${new Intl.NumberFormat(
                                            "es-ES"
                                        ).format(
                                            row.cantidadTotal ?? 0
                                        )} kg`,
                                },
                            ]}
                            dataTable={transporteGestionResiduos}
                            keyProp="codProductor"
                            searchTerms={[
                                "codProductor",
                                "cantidadTransporte",
                                "cantidadDestinoFinal",
                                "cantidadResiduoGenerada",
                            ]}
                            noResultsMessage="No hay datos de transporte gestión residuos disponibles"
                            rowsPerPage={10}
                            showCheckboxes={false}
                            loading={loading}
                            elementName="Transporte Gestión Residuos"
                            stateProp="codEstado"
                        />
                    </div>
                );
            case "visitas":
                return renderVisitas();
            default:
                return null;
        }
    };

    return (
        <DetalleLayout
            title={gestor ? `Gestor ${gestor.nombre}` : "Cargando..."}
            backLink="/gestores"
            backText="Volver a Gestores"
            loading={loading}
            error={error}
            notFound={!gestor && !loading && !error}
            className="ficha-gestor"
        >
            {!loading && !error && gestor && (
                <div className="ficha-gestor__content">
                    <div className="ficha-gestor__section">
                        <div className="ficha-gestor__section-header">
                            <h2>Información General</h2>
                        </div>

                        <TabsNavigation
                            tabs={tabsGeneral}
                            activeTab={activeTabGeneral}
                            onTabChange={setActiveTabGeneral}
                            noBorderRadius={true}
                        />

                        <div className="ficha-gestor__section-content">
                            {renderGeneralContent()}
                        </div>
                    </div>

                    <div className="ficha-gestor__section">
                        <div className="ficha-gestor__section-header">
                            <h2>Datos del gestor</h2>
                        </div>

                        <TabsNavigation
                            tabs={tabsDatos}
                            activeTab={activeTabDatos}
                            onTabChange={setActiveTabDatos}
                            noBorderRadius={true}
                        />

                        <div className="ficha-gestor__section-content">
                            {renderDatosContent()}
                        </div>
                    </div>
                </div>
            )}

            {/* Documentos, certificados y facturas del gestor comparten el tipo
                de validación 7 (ProveedoresDocumentos) y la clave codDocumento. */}
            <ValidacionesHistorico
                isOpen={isHistoricoModalOpen}
                onClose={() => setIsHistoricoModalOpen(false)}
                codTipoValidacion={7}
                codClave={
                    documentoSeleccionado?.CodClave ??
                    documentoSeleccionado?.codDocumento
                }
            />

            <VisitaDetalleModal
                isOpen={isVisitaModalOpen}
                onClose={() => setIsVisitaModalOpen(false)}
                visita={visitaSeleccionada}
                gestorNombre={gestor?.nombre}
            />

            <Notification ref={notificationRef} />
        </DetalleLayout>
    );
}
